export default {"src":"/_next/static/image/public/images/flags/flag_44.6a18f3e7e7606b5bb83af83c650cebde.svg","height":16,"width":24};